import styled from '@emotion/styled';

export const CoursesReportsFiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;
